import DisplayData from "./DisplayData";

interface AddressDataProps {
    text?: string;
    AddressLine1: string | undefined | null;
    AddressLine2: string | undefined | null;
    City: string | undefined | null;
    State: string | undefined | null;
    ZipCode: string | undefined | null;
    County?: string | undefined | null;
    hideColon?: boolean;
    isBold?: boolean;
}


const AddressData = (props: AddressDataProps) => {

    return (
        <>
            {props.AddressLine1 && props.City && props.State && props.ZipCode && (
                <DisplayData
                    text={props.text}
                    hideColon={props.hideColon}
                    isBold={props.isBold}
                    importedData={
                        <>
                            {props.AddressLine1}<br />
                            {props.AddressLine2 && (<> {props.AddressLine2}<br /> </>)}
                            {props.City}{","} {props.State} {props.ZipCode}<br />
                            {props.County && (<> {props.County} </>)}
                        </>
                    }
                />
            )}
        </>
    );
};

export default AddressData;
